module.exports = __webpack_public_path__ + "img/s3.fd215ba1.png";